import { createSlice } from '@reduxjs/toolkit';
import { fetchOvertimeStatistics } from '../thunks/overtimeStatisticsThunks.js';

const initialState = {
    isLoading: false,
    maxPageNumber: 0,
    overtimeStatistics: [],
    error: undefined,
};

const overtimeStatisticsSlice = createSlice({
    name: 'overtimeStatistics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOvertimeStatistics.pending, (state) => {
                state.isLoading = true;
                state.error = undefined;
            })
            .addCase(fetchOvertimeStatistics.fulfilled, (state, action) => {
                state.overtimeStatistics = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchOvertimeStatistics.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || action.error?.message;
            })
            .addDefaultCase((state) => state);
    },
});

export default overtimeStatisticsSlice.reducer;
